'use strict';

import React from 'react';
import flux from 'utils/flux';
import {Link} from 'react-router';
import classnames from 'classnames';
import api from 'utils/api';
import MediaSlideshow from './mediaSlideshow';

const UrlRegex = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi);

var MediaFeatured = React.createClass({
    displayName: 'mediaFeatured',
    propTypes: {
        media: React.PropTypes.object
    },
    componentWillMount() {
        flux.getStore('media').loadLandingPage();
    },

    render() {
        if (this.props.landingPage.size === 0) {
            return false;
        }

        let getItemUrlType = (item) => {
          let type;
          if ( item.href !== undefined && item.href !== '' && item.href.match(UrlRegex) ) {
            type = 'url';
          } else {
            type = 'searchId';
          }
          return type;
        };

        var slides = this.props.landingPage.filter( slide => slide.get('slide') ).toJS().map( item => {
            let type = getItemUrlType(item);
            item.type = type;
            return item;
        } );
        var teasers = this.props.landingPage.filter( teaser => !teaser.get('slide') ).toJS().map( item => {
            let type = getItemUrlType(item);
            item.type = type;
            return item;
        } );


        var invertFloat = false;

        return (
            <div>
                {slides.length ? <MediaSlideshow slides={slides} /> : ''}
                <div className="media__featured">
                {teasers.map((item, ix) => {
                    var isPromo = item.promo;
                    if ( isPromo ) {
                        invertFloat = !invertFloat;
                    }

                    let itemContent = (
                        <div>
                            <div className="item__image">
                                <img src={api.cachedImagePath(item.image)} />
                            </div>
                            <span className="item__overlay">
                                <span className="overlay__title">{item.title}</span>
                                <span className="overlay__subtitle">
                                    {item.subtitle}
                                    {(!!item.subtitle) ?
                                      <span className="play-icon"/>
                                    : ''
                                    }
                                </span>
                                <span className="overlay__text">{item.text}</span>
                            </span>
                        </div>
                    );

                    let itemLink = ((item.type == 'url') ?
                        (
                            <a key={'s-' + ix} href={item.href} className={classnames('featured__item', {'featured__item--promo': isPromo}, {'invert-float': !isPromo && invertFloat})} target="_blank">
                              {itemContent}
                            </a>
                        )
                    :
                        (
                            <Link key={'s-' + ix} to="listing" query={{search_id: item.searchId}} className={classnames('featured__item', {'featured__item--promo': isPromo}, {'invert-float': !isPromo && invertFloat})}>
                                {itemContent}
                            </Link>
                        )
                    );

                    return (
                        {itemLink}
                    );
                })}
                </div>
            </div>
        );
    }
});

module.exports = MediaFeatured;



// WEBPACK FOOTER //
// ./app/pages/media/mediaFeatured.jsx